import {call, cancelled, fork, put, select, take, takeLatest} from 'redux-saga/effects';
import {eventChannel} from 'redux-saga';
import {throttledActionGenerator} from './throttledActionGenerator';
import {WAVE_SOCKET_TOPICS} from "../../../constants/equity/socketConstants";
import {
	getCurrentOrderId,
	resetOrderFeed,
	setOrderFeed,
	setOrderFeedThrottled,
	startLister,
	stopLister,
} from "../../reducers/equity/tradeSocketListener";
import commonBaseService from "../../../services/commonBaseService";

function createSocketChannel(EventBus) {
	return eventChannel((emit) => {
		const pingHandler = (message) => {
			emit(message);
		};
		if (EventBus.on) {
			EventBus.on(WAVE_SOCKET_TOPICS.ORDER_PLACED, pingHandler);
		}

		return () => {
			if (EventBus.off) {
				EventBus.off(WAVE_SOCKET_TOPICS.ORDER_PLACED, pingHandler);
			}
		};
	});
}

function* stopSocketChannel(socketChannel) {
	yield take(stopLister.toString());
	socketChannel.close();
}

function* handelStartLister({payload}) {
	const {EventBus} = payload;
	yield put(resetOrderFeed());
	const socketChannel = yield call(createSocketChannel, EventBus);
	yield fork(stopSocketChannel, socketChannel);

	while (true) {
		try {
			const message = yield take(socketChannel);
			if (message.UniqueCode) {
				const orderId = yield select(getCurrentOrderId);
				if (commonBaseService.isEmptyOrUndefined(orderId)) {
					yield put(setOrderFeed(message));
				} else {
					yield put(setOrderFeedThrottled(message));
				}
			}
		} catch (err) {
			console.error('handelStartLister error:', err);
		} finally {
			if (yield cancelled()) {
				put(stopLister());
			}
		}
	}
}

export default function* tradeSocketListenerSaga() {
	yield takeLatest(startLister.toString(), handelStartLister);
	yield throttledActionGenerator(setOrderFeedThrottled, setOrderFeed, 300);
}
